import React, { useState } from 'react';
import { Tooltip } from 'react-tooltip';
import { InfoBoxPlacements } from '../constants';
import { colors } from '../Utils/utils';
import Icon from '../Components/Icon';
import { uniqueId } from 'lodash-es';

const currentTheme = window.__litium.currentTheme;

const InfoBox = ({
  label,
  id,
  placement = InfoBoxPlacements.Top,
  children,
}) => {
  const uid = uniqueId();
  const tooltipId = id + '-' + uid;

  const [isOpen, setIsOpen] = useState(false);
  return id ? (
    <div className="info-box">
      {label && (
        <button
          className="info-box__trigger"
          data-tooltip-id={tooltipId}
          data-tooltip-place={placement}
          onClick={() => setIsOpen(!isOpen)}
        >
          {label}
        </button>
      )}
      {children && isOpen && (
        <Tooltip
          id={tooltipId}
          isOpen={isOpen}
          border={`1px solid ${colors[currentTheme].infoBoxBorder}`}
          className="info-box__tooltip"
          classNameArrow="info-box__arrow"
          opacity={1}
          clickable={true}
          place={placement}
        >
          <div className="infobox__content">
            <button
              className="info-box__close"
              onClick={() => setIsOpen(false)}
            >
              <Icon name="Close" size={16} className="info-box__close-icon" />
            </button>
            {children}
          </div>
        </Tooltip>
      )}
    </div>
  ) : null;
};

export default InfoBox;
